import Modal from "shared/modal";

import Backdraft from "backdraft-app/src/backdraft";

Backdraft.plugin("ModalDialog", function(plugin) {
  plugin.initializer(function(app) {
    app.installPlugin("Base");

    app.view.modal = function(name, baseClassName, properties) {
      var baseClass = Modal;
      if (arguments.length === 2) {
        properties = baseClassName;
      } else {
        baseClass = app.Views[baseClassName];
      }

      app.Views[name] = baseClass.extend(properties);
    };
  });

  plugin.exports({
    Modal
  });
});
